module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/selectable-tabs/expert-screen-components/expert-color/expert-color-component.css
// module id = ./src/app/components/selectable-tabs/expert-screen-components/expert-color/expert-color-component.css
// module chunks = main